module.exports = __webpack_public_path__ + "static/img/1-2-5.f4f50d86.jpg";